<div class="di-teletransmission__container">
	<iframe *ngIf="iframeSrc" #iframe [src]="iframeSrc" frameborder="0" width="100%" height="100%"></iframe>
</div>